import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  section4CenterRight: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
    paddingBottom: 20,
    marginTop: 'auto', // Push to bottom of available space
  },
  bottomText: {
    fontSize: 24,
    color: '#FFFCE8',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
  },
  headerTextContr: {
    position: 'relative',
    width: '100%',
    textAlign: 'center',
  },
  headerText: {
    position: 'absolute',
    width: '100%',
    fontSize: 32,
    color: '#FFFCE8',
    textAlign: 'center',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
  },
});

const headerText = 'A better future is in your hands.';

const Footer = () => {
  return (
    <View style={styles.section4CenterRight}>
      <View style={styles.headerTextContr}>
        <Text style={{ ...styles.headerText, top: 2, color: '#bf9e00' }}>
          {headerText}
        </Text>
        <Text style={styles.headerText}>{headerText}</Text>
      </View>
    </View>
  );
};

export default Footer;
